'use client'

import { useNavigation } from 'hooks/useNavigation/useNavigation'
import { StorePreviousUrl } from 'links/login/shared/StorePreviousUrl'
import {
	GUEST_TAB_PATHNAME,
	LOGIN_PATHNAME,
	LOGIN_TAB_PATHNAME,
} from 'my-purchases/constants/paths'
import { useGuestEmail } from 'my-purchases/hooks/useGuestEmail/useGuestEmail'
import { shouldRedirectToLogin } from 'my-purchases/utils/shouldRedirectToLogin/shouldRedirectToLogin'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useSession } from 'session/src/hooks/useSession'

export function RedirectToLogin({ isGuestAllowed = true }) {
	const { isReady, logged } = useSession()
	const guestEmail = useGuestEmail()
	const { navigate } = useNavigation()
	const searchParams = useSearchParams()
	const searchString = searchParams?.toString()
	const orderId = searchParams?.get('orderId')

	useEffect(() => {
		if (
			shouldRedirectToLogin({
				isReady,
				logged,
				guestEmail,
				orderId,
				isGuestAllowed,
			})
		) {
			const loginLink = searchString
				? `${LOGIN_PATHNAME}?${searchString}`
				: LOGIN_TAB_PATHNAME

			navigate(orderId ? GUEST_TAB_PATHNAME : loginLink)
		}
	}, [isReady, logged])

	return <StorePreviousUrl />
}
